
export function jsonParseSafe(str, defaultValue) {
    try {
        return JSON.parse(str);
    }
    catch{
        return defaultValue
    }
}